import React, { ChangeEvent, FC, useCallback } from 'react';

import './EditableText.scss';

interface Props {
  readonly text: string;
  readonly onChange: (text: string) => void;
}

export const EditableText: FC<Props> = ({ text, onChange }) => {
  const onInputChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
    },
    [onChange],
  );

  return <input className="editable-text" onChange={onInputChange} type="text" value={text} />;
};
